

























import { Component, Vue, Prop, Mixins } from "vue-property-decorator";

import BaseButton from "@/components/BaseButton/BaseButton.vue";
import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";

import ButtonsMixin from "@/mixins/Buttons.mixin";

@Component({
  components: {
    BaseButton,
    Spinner
  }
})
export default class BaseAsyncButton extends Mixins(ButtonsMixin) {
  @Prop({ default: false, type: Boolean })
  private pending!: boolean;

  @Prop({ default: "white", type: String })
  private spinnerColor!: string;
}
